/**
 * The document mark above *"Your next steps"* [Figma `10a · Your next steps` — 12446:28081].
 *
 * **Not the success mark.** `10a` and `11 · That's it for now` sit next to each other and carry two
 * different badges on purpose: the green tick belongs to the closeout, where the candidate IS finished,
 * and this teal document belongs here, on the screen whose job is to explain what is still coming. The
 * build had the tick on both, which said "you are done" one screen early.
 *
 * Geometry is byte-identical to the I-9 screen's badge in the file — same 56px circle, same 24px glyph —
 * because it is the same component instance there.
 *
 * `aria-hidden`: the heading beside it says the same thing, and a screen reader announcing a decorative
 * document before reading "Your next steps" is noise rather than information.
 */
export function NextStepsBadge() {
  return (
    <div
      aria-hidden
      className="flex size-14 items-center justify-center rounded-full bg-[var(--primary-muted)]"
    >
      <svg
        className="size-6"
        fill="none"
        stroke="var(--primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.8}
        viewBox="0 0 24 24"
      >
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6Z" />
        <path d="M14 2v6h6M9 15h6" />
      </svg>
    </div>
  );
}
